/* eslint-disable prettier/prettier */
import api from '@/api'
import store from '@/store'
import axios from 'axios'
import { Toast, Notify } from 'vant'
import html2canvas from '@/utils/html2canvas'
/**
 * @description 格式化时间
 * @param time
 * @param cFormat
 * @returns {string|null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  }
  return format.replace(/{([ymdhisa])+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
}

/**
 * @description 格式化时间
 * @param time
 * @param option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @description 将url请求参数转为json格式
 * @param url
 * @returns {{}|any}
 */
export function paramObj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
    decodeURIComponent(search)
      .replace(/"/g, '\\"')
      .replace(/&/g, '","')
      .replace(/=/g, '":"')
      .replace(/\+/g, ' ') +
    '"}'
  )
}

/**
 * @description 父子关系的数组转换成树形结构数据
 * @param data
 * @returns {*}
 */
export function translateDataToTree(
  data,
  isParentKey = 'ParentId',
  isParentValue = '0',
  childrenKey = 'id'
) {
  const parent = data.filter((value) => value[isParentKey] === isParentValue)
  const children = data.filter((value) => value[isParentKey] !== isParentValue)
  const translator = (parent, children) => {
    parent.forEach((parent) => {
      children.forEach((current, index) => {
        if (current[isParentKey] === parent[childrenKey]) {
          const temp = JSON.parse(JSON.stringify(children))
          temp.splice(index, 1)
          translator([current], temp)
          typeof parent.children !== 'undefined'
            ? parent.children.push(current)
            : (parent.children = [current])
        }
      })
    })
  }
  translator(parent, children)
  return parent
}

/**
 * @description 树形结构数据转换成父子关系的数组
 * @param data
 * @returns {[]}
 */
export function translateTreeToData(data) {
  const result = []
  data.forEach((item) => {
    const loop = (data) => {
      result.push({
        id: data.id,
        name: data.name,
        parentId: data.parentId,
      })
      const child = data.children
      if (child) {
        for (let i = 0; i < child.length; i++) {
          loop(child[i])
        }
      }
    }
    loop(item)
  })
  return result
}

/**
 * @description 10位时间戳转换
 * @param time
 * @returns {string}
 */
export function tenBitTimestamp(time) {
  const date = new Date(time * 1000)
  const y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? '' + m : m
  let d = date.getDate()
  d = d < 10 ? '' + d : d
  let h = date.getHours()
  h = h < 10 ? '0' + h : h
  let minute = date.getMinutes()
  let second = date.getSeconds()
  minute = minute < 10 ? '0' + minute : minute
  second = second < 10 ? '0' + second : second
  return y + '年' + m + '月' + d + '日 ' + h + ':' + minute + ':' + second //组合
}

/**
 * @description 13位时间戳转换
 * @param time
 * @returns {string}
 */
export function thirteenBitTimestamp(time) {
  const date = new Date(time / 1)
  const y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? '' + m : m
  let d = date.getDate()
  d = d < 10 ? '' + d : d
  let h = date.getHours()
  h = h < 10 ? '0' + h : h
  let minute = date.getMinutes()
  let second = date.getSeconds()
  minute = minute < 10 ? '0' + minute : minute
  second = second < 10 ? '0' + second : second
  return y + '年' + m + '月' + d + '日 ' + h + ':' + minute + ':' + second //组合
}

/**
 * @description 获取随机id
 * @param length
 * @returns {string}
 */
export function uuid(length = 32) {
  const num = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'
  let str = ''
  for (let i = 0; i < length; i++) {
    str += num.charAt(Math.floor(Math.random() * num.length))
  }
  return str
}

/**
 * @description m到n的随机数
 * @param m
 * @param n
 * @returns {number}
 */
export function random(m, n) {
  return Math.floor(Math.random() * (m - n) + n)
}

/**
 * @description addEventListener
 * @type {function(...[*]=)}
 */
export const on = (function () {
  return function (element, event, handler, useCapture = false) {
    if (element && event && handler) {
      element.addEventListener(event, handler, useCapture)
    }
  }
})()

/**
 * @description removeEventListener
 * @type {function(...[*]=)}
 */
export const off = (function () {
  return function (element, event, handler, useCapture = false) {
    if (element && event) {
      element.removeEventListener(event, handler, useCapture)
    }
  }
})()

/**
 * @description 数组打乱
 * @param array
 * @returns {*}
 */
export function shuffle(array) {
  let m = array.length,
    t,
    i
  while (m) {
    i = Math.floor(Math.random() * m--)
    t = array[m]
    array[m] = array[i]
    array[i] = t
  }
  return array
}

/**
 * 数组对象根据key,value排序
 * @date 2021-08-20
 * @param {any} array
 * @param {any} key
 * @returns {any} 原数组
 */
export function arrayObjectSort(array, key) {
  array.sort(function (a, b) {
    return a[key] - b[key]
  })
}

/**
 * JS获取树的父节点及祖先节点
 * @date 2021-08-20
 * @param {any} node
 * @param {any} tree
 * @param {any} parentNodes=[]
 * @param {any} index=0
 * @returns {any}
 */
export function treeFindPath(tree, func, path = []) {
  if (!tree) return []
  for (const data of tree) {
    // 这里按照你的需求来存放最后返回的内容吧
    path.push(data)
    if (func(data)) return path
    if (data.children) {
      const findChildren = treeFindPath(data.children, func, path)
      if (findChildren.length) return findChildren
    }
    path.pop()
  }
  return []
}

/**
 * 通过url获取图片blod 并上传至服务器
 * @author hanson.liu
 * @date 2021-09-27
 * @param {any} imgsrc
 * @returns {any}
 */
export const uploadFromUrl = async (imgsrc) => {
  const blob = await compressImage(imgsrc)
  const param = new FormData()
  param.append('formFile', blob)
  const token = store.getters['user/token']
  return axios({
    method: 'POST',
    url: api.UploadImage,
    data: param,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  })
}

/**
 * 压缩
 * @author hanson.liu
 * @date 2021-09-23
 * @param {any} file
 * @returns {any} Promise 小于2M的图片
 */
export const compressImage = (imgsrc) => {
  return new Promise((resolve, reject) => {
    let image = new Image()
    let resultBlob = ''
    image.setAttribute('crossOrigin', 'anonymous')
    image.onload = () => {
      let quality = 0.9
      // 调用方法获取blob格式，方法写在下边
      resultBlob = getCompressImage(image, '', quality)
      resolve(resultBlob)
    }
    image.onerror = (e) => {
      reject(e)
    }
    image.src = imgsrc
  })
}

export const getCompressImage = (image, file, quality) => {
  let resultBlob = compressUpload(image, file, quality)
  // 压缩至小于2M为止
  if (resultBlob.size > 1024 * 1024 * 2) {
    let q = quality - 0.1
    q <= 0 ? (q = 0.1) : q
    return getCompressImage(image, file, q)
  }
  console.log('压缩完成，质量：' + quality * 100 + '%')
  return resultBlob
}

/* 图片压缩方法-canvas压缩 */
const compressUpload = (image, file, quality) => {
  let canvas = document.createElement('canvas')
  let ctx = canvas.getContext('2d')
  //let initSize = image.src.length
  let { width } = image,
    { height } = image
  canvas.width = width
  canvas.height = height
  ctx.fillRect(0, 0, canvas.width, canvas.height)
  ctx.drawImage(image, 0, 0, width, height)
  let compressData = canvas.toDataURL(file.type || 'image/jpeg', quality)

  // 压缩后调用方法进行base64转Blob，方法写在下边
  let blobImg = dataURItoBlob(compressData)
  return blobImg
}

/* base64转Blob对象 */
const dataURItoBlob = (data) => {
  let byteString
  if (data.split(',')[0].indexOf('base64') >= 0) {
    byteString = atob(data.split(',')[1])
  } else {
    byteString = unescape(data.split(',')[1])
  }
  let mimeString = data.split(',')[0].split(':')[1].split(';')[0]
  let ia = new Uint8Array(byteString.length)
  for (let i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i)
  }
  return new Blob([ia], { type: mimeString })
}

export const getAvator = (url) => {
  let res = null
  if (url) {
    res = api.FileHost + url
  } else {
    res = require('@/assets/images/logo.png')
  }
  return res
}

/**
 * 描述
 * @author hanson.liu
 * @date 2022-06-02
 * @param {string} title 分享标题
 * @param {string} desc 分享描述
 * @param {string} imgUrl 分享的图片url
 * @param {string} shareUrl 分享链接 不传为默认当前页面
 * @returns {any}
 */
export const wxShare = (title, desc, imgUrl, shareUrl) => {
  setTimeout(async () => {
    const tenant = await store.getters['user/getTenant']
    if (!imgUrl) {
      imgUrl =
        'https://wx3.sinaimg.cn/mw1024/9daef013gy1gw9v4ql63dj201i01ia9t.jpg'
      if (tenant.LogoSmall) {
        imgUrl = api.FileHost + tenant.LogoSmall
      }
    }
    // 微信分享start
    const url = location.href.split('#')[0]
    //const url = 'http://wx.tengyuone.com/zeyu/case/'
    store
      .dispatch('user/WechatGetJSSdkInfo', '"' + url + '"')
      .then(({ Data }) => {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: Data.appId, // 必填，公众号的唯一标识
          timestamp: Data.timestamp, // 必填，生成签名的时间戳
          nonceStr: Data.nonceStr, // 必填，生成签名的随机串
          signature: Data.signature, // 必填，签名
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 必填，需要使用的JS接口列表
        })
        //const tenantName = store.getters['user/getTenant'].TenantName
        //const title = '用户协议'
        //const desc = '请认真阅读并同意协议'

        wx.ready(function () {
          // 分享给朋友
          wx.updateAppMessageShareData({
            title: title ? title : tenant.TenantName, // 分享标题
            desc: desc, // 分享描述
            link: shareUrl ? shareUrl : location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: imgUrl, // 分享图标
            success: () => { },
          })
          // 分享到朋友圈
          wx.updateTimelineShareData({
            title: title ? title : tenant.TenantName, // 分享标题
            //desc: desc, // 分享描述
            link: shareUrl ? shareUrl : location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: imgUrl, // 分享图标
            success: () => { },
          })
        })
      })
  })
}
export const dataURItoBlobv2 = (data, name) => {
  let byteString
  if (data.split(',')[0].indexOf('base64') >= 0) {
    byteString = atob(data.split(',')[1])
  } else {
    byteString = unescape(data.split(',')[1])
  }
  let mimeString = data.split(',')[0].split(':')[1].split(';')[0]
  let ia = new Uint8Array(byteString.length)
  for (let i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i)
  }
  const bold = new Blob([ia], { type: mimeString })
  return new File([bold], name)
}

export const uploadFile = async (blob) => {
  const param = new FormData()
  param.append('formFile', blob)
  const token = store.getters['user/token']
  return axios({
    method: 'POST',
    url: api.UploadFile,
    data: param,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const img2Base64 = (img) => {
  return new Promise((resolve, reject) => {
    var image = new Image()
    image.crossOrigin = '*'
    image.onload = function () {
      var ext = img.src.substring(img.src.lastIndexOf('.') + 1)
      var canvas = document.createElement('canvas')
      canvas.width = image.width
      canvas.height = image.height
      var context = canvas.getContext('2d')
      context.drawImage(image, 0, 0, image.width, image.height)

      // 这里是不支持跨域的
      var base64 = canvas.toDataURL('image/' + ext)
      resolve(base64)
    }
    image.onerror = function (e) {
      reject(e)
    }
    image.src = img.src
  })
}

/**
 * 解决两个数相加精度丢失问题
 * @param a
 * @param b
 * @returns {Number}
 */
function floatAdd(a, b) {
  var c, d, e
  if (undefined == a || null == a || '' == a || isNaN(a)) {
    a = 0
  }
  if (undefined == b || null == b || '' == b || isNaN(b)) {
    b = 0
  }
  try {
    c = a.toString().split('.')[1].length
  } catch (f) {
    c = 0
  }
  try {
    d = b.toString().split('.')[1].length
  } catch (f) {
    d = 0
  }
  e = Math.pow(10, Math.max(c, d))
  return (floatMul(a, e) + floatMul(b, e)) / e
}
/**
 * 解决两个数相减精度丢失问题
 * @param a
 * @param b
 * @returns {Number}
 */
function floatSub(a, b) {
  var c, d, e
  if (undefined == a || null == a || '' == a || isNaN(a)) {
    a = 0
  }
  if (undefined == b || null == b || '' == b || isNaN(b)) {
    b = 0
  }
  try {
    c = a.toString().split('.')[1].length
  } catch (f) {
    c = 0
  }
  try {
    d = b.toString().split('.')[1].length
  } catch (f) {
    d = 0
  }
  e = Math.pow(10, Math.max(c, d))
  return (floatMul(a, e) - floatMul(b, e)) / e
}
/**
 * 解决两个数相乘精度丢失问题
 * @param a
 * @param b
 * @returns {Number}
 */
function floatMul(a, b) {
  var c = 0,
    d = a.toString(),
    e = b.toString()
  try {
    c += d.split('.')[1].length
  } catch (f) {
    //console.log(f)
  }
  try {
    c += e.split('.')[1].length
  } catch (f) {
    //console.log(f)
  }
  return (
    (Number(d.replace('.', '')) * Number(e.replace('.', ''))) / Math.pow(10, c)
  )
}
/**
 * 复制文本内容功能
 * @param {*} value  参数 文本内容
 */
function copyText(value) {
  document.designMode = 'on'
  const input = document.createElement('input')
  document.body.appendChild(input)
  input.setAttribute('value', value)
  input.setAttribute('readonly', 'readonly')
  input.select()
  try {
    var successful = document.execCommand('copy')
    var msg = successful ? 'successful' : 'unsuccessful'
    // console.log('Copy email command was ' + msg);
    if (!successful) {
      throw new Error('copy failed')
    }
    Toast('复制成功')
  } catch (err) {
    console.log('Oops, unable to copy')
    Toast('复制失败，请重试或手动复制')
  }
  document.body.removeChild(input)
  document.designMode = 'off'
}
/**
 * 解决两个数相除精度丢失问题
 * @param a
 * @param b
 * @returns
 */
function floatDiv(a, b) {
  var c,
    d,
    e = 0,
    f = 0
  if (!a) return
  try {
    e = a.toString().split('.')[1].length
  } catch (g) {
    //console.log(g)
  }
  try {
    f = b.toString().split('.')[1].length
  } catch (g) {
    //console.log(g)
  }
  return (
    (c = Number(a.toString().replace('.', ''))),
    (d = Number(b.toString().replace('.', ''))),
    floatMul(c / d, Math.pow(10, f - e))
  )
}

export { floatAdd, floatSub, floatMul, floatDiv, copyText }

/**
 * 大额数字转换为万、千万、亿等
 * @param value 数字值
 */
export function bigNumberTransform(value) {
  if (value !== undefined && value !== null) {
    if (Number(value) < 10000) {
      let str = value.toString()
      return str
    } else {
      let str = floatDiv(value, 10000).toFixed(2)
      return str + '万'
    }
  } else {
    return ''
  }
}

export function money(val) {
  return floatDiv(val, 100)
}

export const getExpire = (datetime) => {
  let res = ''
  if (datetime) {
    var date = new Date()
    var until = new Date(datetime)
    //var until = new Date('2022-3-16 20:00:00')
    // 计算时会发生隐式转换，调用valueOf()方法，转化成时间戳的形式
    var days = (until - date) / 1000 / 3600 / 24
    // 下面都是简单的数学计算
    var day = Math.floor(days)
    var hours = (days - day) * 24
    var hour = hours.toFixed(2)
    // var minutes = (hours - hour) * 60
    // var minute = Math.floor(minutes)
    // var seconds = (minutes - minute) * 60
    // var second = Math.floor(seconds)
    if (days <= 0) {
      res = '您的服务已过期'
    }
    if (days <= 1 && days > 0) {
      res = `您的服务还有${hour}小时到期`
    }
    if (days <= 30 && days > 1) {
      res = `您的服务还有${day}天到期`
    }
  }
  return res
}

/**
 * 描述
 * @author hanson.liu
 * @date 2022-06-07
 * @param {any} elem 需要截图的包裹的（原生的）DOM 对象
 * @returns {any}
 */
export const toImg = async (elem) => {
  var opts = {
    width: parseInt(elem.offsetWidth),
    height: parseInt(elem.offsetHeight),
    allowTaint: false,
    taintTest: true,
    useCORS: true,
    tainttest: true, //检测每张图片都已经加载完成
    scale: 2, // 设备像素比
    ignoreElements: (element) => {
      // 可从渲染中删除匹配的元素
      if (element.className === 'exclude') return true
    },
  }

  return (window.html2canvas || html2canvas)(elem, opts)
  // .then((res) => {
  //   const url = res.toDataURL('image/jpeg', 1)
  // })
  // .catch((e) => {})
}

export const getWXOpenId = async (url) => {
  const { Code, Data } = await store
    .dispatch('user/WechatGetAppID')
    .catch((e) => {
      Notify('获取appId失败，请稍后重试！')
    })
  if (Code !== 0) {
    Notify('获取appId失败，请稍后重试！')
    return
  }
  const appId = Data.AppId
  const state = Data.State

  const uri = encodeURIComponent(url)
  window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${uri}&response_type=code&scope=snsapi_base&state=${state}#wechat_redirect`
}

/**
 * @description: 控制input框只能输入数字  小数点后两位
 */
export const clearNum = (value) => {
  let filterValue = value.toString()
  filterValue = filterValue.replace(/^\./g, '') //  不能以“.”开头
  filterValue = filterValue.replace(/[^\d.]/g, '') //清除“数字”和“.”以外的字符
  filterValue = filterValue.replace(/\.{2,}/g, '.') //只保留第一个. 清除多余的
  filterValue = filterValue
    .replace('.', '$#$')
    .replace(/\./g, '')
    .replace('$#$', '.')
  filterValue = filterValue.replace(/^(-)*(\d+)\.(\d\d).*$/, '$1$2.$3') //只能输入两个小数
  if (filterValue.indexOf('.') < 0 && filterValue != '') {
    //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
    filterValue = parseFloat(filterValue)
  }
  return filterValue
}


export const getTenantCode = () => {
  let pathname = location.pathname.split('/')
  let tenantCode = pathname[1]
  if (!tenantCode) {
    tenantCode = api.defaultTenant
  }
  return tenantCode
}

/**
 * 判断是否是微信内打开
 * @author hanson.liu
 * @date 2022-08-18
 * @returns {boolean}
 */
export function isWeixin() {
  var ua = navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}